export default __webpack_public_path__ + "static/media/Necklace of Wormfire.69460b75.jpg";